import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const OrderSettingsBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Заказы',
        url: '',
    },
    {
        key: '2',
        value: 'Настройки',
        url: '',
    },
]);
